export const brpClubDealerSelectionTriggerParam = 'openDealerSelect';

export const getActiveCartWorkCount = cart =>
  (cart?.cartItems?.length ?? 0) + (cart?.cartWalls?.length ?? 0) + (cart?.cartToolings?.length ?? 0);

export const hasActiveCartWork = cart => getActiveCartWorkCount(cart) > 0;

export const getActiveMerchandisingProgramQuoteWorkCount = merchandisingProgramQuote =>
  merchandisingProgramQuote?.quoteItems?.length ?? 0;

export const hasActiveMerchandisingProgramQuoteWork = merchandisingProgramQuote =>
  getActiveMerchandisingProgramQuoteWorkCount(merchandisingProgramQuote) > 0;

export const getActiveExteriorSignageQuoteWorkCount = exteriorSignageQuote => exteriorSignageQuote?.quoteItems?.length ?? 0;

export const hasActiveExteriorSignageQuoteWork = exteriorSignageQuote =>
  getActiveExteriorSignageQuoteWorkCount(exteriorSignageQuote) > 0;

export const hasAnyActiveDealerWork = ({ cart, merchandisingProgramQuote, exteriorSignageQuote }) =>
  hasActiveCartWork(cart) ||
  hasActiveMerchandisingProgramQuoteWork(merchandisingProgramQuote) ||
  hasActiveExteriorSignageQuoteWork(exteriorSignageQuote);

export const shouldAutoOpenBrpClubDealerSelection = ({
  isClub,
  isLoading,
  cart,
  merchandisingProgramQuote,
  exteriorSignageQuote,
}) =>
  isClub &&
  !isLoading &&
  !hasAnyActiveDealerWork({
    cart,
    merchandisingProgramQuote,
    exteriorSignageQuote,
  });

export const isBrpClubDealerSelectionTriggerRequested = search => {
  const searchParams = new URLSearchParams(search || '');
  return searchParams.get(brpClubDealerSelectionTriggerParam) === '1';
};

export const removeBrpClubDealerSelectionTrigger = search => {
  const searchParams = new URLSearchParams(search || '');
  searchParams.delete(brpClubDealerSelectionTriggerParam);
  return searchParams.toString();
};

export const buildPathWithBrpClubDealerSelectionTrigger = (pathname, search = '') => {
  const searchParams = new URLSearchParams(search || '');
  searchParams.set(brpClubDealerSelectionTriggerParam, '1');

  const nextSearch = searchParams.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ''}`;
};
